<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
// import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import Vue from "vue";
import excel from "vue-excel-export";
Vue.use(excel);
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Payments",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
  },
  data() {
    return {
      title: "Fees Payments",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees Payments",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "tot",
          label: "Fees",
          sortable: true,
        },
        {
          key: "pbal",
          label: "Previous Debts",
          sortable: true,
        },
        {
          key: "expt",
          label: "Exemption",
          sortable: true,
        },
        {
          key: "add",
          label: "Additions",
          sortable: true,
        },
        {
          key: "payable",
          label: "Payable",
          sortable: true,
        },
        {
          key: "paid",
          label: "Paid",
          sortable: true,
        },
        {
          key: "bal",
          label: "Balance",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        class: "",
        term: "",
        year: new Date().getFullYear(),
        stream: "",
      },
      search: {
        class: "",
        term: 0,
        year: moment(new Date()).format("YYYY"),
        stream: "",
      },
      terms: [
        { id: 1, name: "Term 1" },
        { id: 2, name: "Term 2" },
        { id: 3, name: "Term 3" },
      ],
      years: [
        { name: new Date().getFullYear() },
        { name: new Date().getFullYear() - 1 },
        { name: new Date().getFullYear() - 2 },
        { name: new Date().getFullYear() - 3 },
      ],
      pay: {
        name: "",
        id: "",
        amount: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
        paidby: "",
        slip: "",
      },
      amountError: "",
      modeError: "",
      classStr: [],
      classError: "",
      termError: "",
      modal: "",
      json_fields: {
        Name: "name",
        Fees: "tot",
        "Previous Debts": "pbal",
        "Fees Additions": "add",
        "Fees Exemption": "expt",
        Payable: "payable",
        Paid: "paid",
        Balance: "bal",
      },
      feesDefaiters: [],
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesPayments", "SaveStatus"]),
    ...mapGetters("modes", ["Modes"]),
    ...mapGetters("classes", ["CourseLevels", "AllCourses"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesPayments ? this.FeesPayments.length : 1;
    },
  },
  watch: {
    FeesPayments(newVal) {
      if (newVal) {
        this.feesDefaiters = this.FeesPayments.filter(
          (item) => parseInt(item.bal.replace(",", "")) > 0
        );
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesPayments ? this.FeesPayments.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCourses: "classes/fetchCourses",
      FetchCourseLevels: "classes/fetchCourseLevels",
      FetchModes: "modes/fetchModes",
      FetchPayments: "fees/fetchFees",
      PrintfeesDef: "fees/printfeesDef",
      Pay: "fees/pay",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesPayments ? this.FeesPayments.length : 1;
      this.currentPage = 1;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    filterStreams() {
      this.classStr = this.CourseLevels.filter((course) => {
        return course.level == this.data.class;
      });
    },

    fetchFeesDef() {
      this.PrintfeesDef({ details: this.feesDefaiters });
    },

    addCommas() {
      this.pay.amount = this.thousandSeperater(this.pay.amount);
    },

    resetError() {
      this.amountError = "";
      this.modeError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },
    redirect1() {
      if (this.data.class == "") {
        this.classError = "Please Select a Class";
        return;
      }
      if (this.data.term == "") {
        this.termError = "Please Select a Level/Grade";
        return;
      }
      if (this.data.year == "") {
        this.data.year = moment(new Date()).format("YYYY");
      }
      if (this.data.stream == "") {
        this.data.stream = 0;
      }
      this.FetchPayments(this.data);
    },

    payFees(modal) {
      if (this.pay.amount == "") {
        this.amountError = "Amount Paid field can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.pay.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.modal = modal;
      this.Pay(this.pay);
      this.resetError();
      this.closeModal(this.modal);
    },
    showPayModal(values) {
      this.pay.id = values.item.sid;
      this.pay.name = values.item.name;
      this.pay.amount = values.item.bal;
    },
    redirect(value) {
      this.$router.push(`/student/ledger/${btoa(value)}`);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCourses();
    this.FetchCourseLevels();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_payments')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title text-primary">
                  List of Fees Payments
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-1">
                  <label>Course <small class="text-danger">*</small></label>
                  <div class="input-group">
                    <select
                      required
                      class="form-control form-control-sm"
                      v-model="data.class"
                      @change="filterStreams()"
                    >
                      <option value="" selected disabled>Select Course</option>
                      <option
                        v-for="(classDetails, index) in AllCourses"
                        :key="index"
                        :value="classDetails.id"
                      >
                        {{ classDetails.name }}
                      </option>
                    </select>
                  </div>
                  <div class="text-danger" v-if="classError">
                    <em>{{ classError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-1">
                  <label
                    >Level/Grade <small class="text-danger">*</small></label
                  >
                  <div class="input-group">
                    <select
                      class="form-control form-control-sm"
                      v-model="data.term"
                      @input="resetError()"
                    >
                      <option value="" selected disabled
                        >Select Level/Grade</option
                      >
                      <option
                        v-for="(classStream, index) in classStr"
                        :key="index"
                        :value="classStream.id"
                      >
                        {{ classStream.short }}
                      </option>
                    </select>
                  </div>
                  <div class="text-danger" v-if="classError">
                    <em>{{ termError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Year</label>
                  <div class="input-group">
                    <select
                      class="form-control form-control-sm"
                      v-model="data.year"
                      @input="resetError()"
                    >
                      <option
                        v-for="(y, index) in years"
                        :key="index"
                        :value="y.name"
                      >
                        {{ y.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group" align="center">
                  <button
                    class="btn btn-success btn-sm mt-4"
                    @click="redirect1()"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <b-tabs content-class="p-3 text-muted">
                <b-tab active class="border-0">
                  <template v-slot:title>
                    <span class="d-none d-sm-inline-block">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      <b> Fees Payments</b>
                    </span>
                  </template>
                  <div class="row mt-2">
                    <div class="col-md-10">
                      <strong class="text-mute"
                        >List of Student Payment Records</strong
                      >
                    </div>
                    <div class="col-md-2 mb-2">
                      <export-excel
                        :data="FeesPayments"
                        :fields="json_fields"
                        name="Fees Payments.xls"
                      >
                        <b-btn variant="success" class="btn-sm">
                          <i class="fa fa-download"></i>
                          Excel
                        </b-btn>
                      </export-excel>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show&nbsp;
                          <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                          ></b-form-select
                          >&nbsp;entries
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                      >
                        <label class="d-inline-flex align-items-center">
                          Search:
                          <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                  <!-- Table -->
                  <div class="table-responsive mb-0">
                    <b-table
                      class="datatables"
                      :items="FeesPayments ? FeesPayments : []"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                    >
                      <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template>
                      <template #cell(actions)="data">
                        <b-button-group>
                          <!-- <b-button size="sm" variant="primary" v-b-modal.edit-Items-modal @click="showPayModal(data)" v-if="
                              getCurrentUser.permissions.find((item) =>
                                item.permission.includes('make_fees_payments')
                              )
                            "><i class="fa fa-check"></i> Pay</b-button> -->
                          <b-button
                            size="sm"
                            variant="success"
                            @click="redirect(data.item.sid)"
                            ><i class="fa fa-book"></i> Ledger</b-button
                          >
                        </b-button-group>
                      </template>
                    </b-table>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                      >
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab class="border-0">
                  <template v-slot:title>
                    <span class="d-none d-sm-inline-block">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      <b> Fees Balances</b></span
                    >
                  </template>
                  <div class="row">
                    <div class="col-md-10">
                      <strong class="text-mute"
                        >List of Student We are demanding</strong
                      >
                    </div>
                    <div class="col-md-2 mb-2">
                      <b-button-group class="mb-2 float-end">
                        <button
                          v-if="SaveStatus"
                          disabled
                          class="btn btn-sm btn-secondary"
                        >
                          <b-spinner
                            variant="white"
                            small
                            label="Retrieving..."
                          ></b-spinner>
                          Retrieving...
                        </button>
                        <button
                          v-else
                          @click="fetchFeesDef()"
                          class="btn btn-sm btn-secondary"
                        >
                          <i class="fa fa-print"></i>
                          Print PDF
                        </button>
                      </b-button-group>
                    </div>
                    <div class="col-md-12 custom-vert">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">No.</th>
                            <th scope="col">Student Name</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Contact</th>
                            <th scope="col">Stream</th>
                            <th scope="col">Fees Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(student, index) in feesDefaiters"
                            :key="index"
                          >
                            <td scope="row">{{ index + 1 }}</td>
                            <th>{{ student.student_details.name }}</th>
                            <td>{{ student.student_details.gender }}</td>
                            <td>{{ student.student_details.gcontacts }}</td>
                            <td>{{ student.stream }}</td>
                            <th>{{ student.bal }}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>

      <!-- edit modal starts -->
      <!-- <b-modal
        id="edit-Items-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_fees_payments')
          )
        "
      >
        <template #modal-title>Pay Fees For {{ pay.name }}</template>
        <div class="form-group mb-3">
          <label>Amount Paid</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="pay.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Payment Date</label>
          <div class="input-group">
            <input type="date" class="form-control" v-model="pay.date" />
          </div>
        </div>
        <div class="form-group mb-2">
          <label class="col-form-label">Payment Method</label>
          <div class="input-group">
            <model-list-select
              :list="Modes ? Modes : []"
              v-model="pay.mode"
              option-value="id"
              option-text="name1"
              class="mb-3"
              placeholder="Select Payment Method"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Slip Number</label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Enter Slip Number"
              class="form-control"
              v-model="pay.slip"
            />
          </div>
          <small class="text-primary"
            >Bank Slip Number Or Reference Number</small
          >
        </div>
        <div class="form-group mb-3">
          <label>Paid By</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Person who paid fees"
              class="form-control"
              v-model="pay.paidby"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-Items-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="payFees('edit-Items-modal')"
          >
            <i class="fa fa-check"></i>
            Save Payment</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal> -->
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
